import { render } from "./DiscoverCourses.vue?vue&type=template&id=16cfd403&scoped=true"
import script from "./DiscoverCourses.vue?vue&type=script&lang=js"
export * from "./DiscoverCourses.vue?vue&type=script&lang=js"

import "./DiscoverCourses.vue?vue&type=style&index=0&id=16cfd403&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16cfd403"]])

export default __exports__